import { observable, computed } from 'mobx'
import { once } from 'lodash-es'
import { Model, type ModelProps } from '@/infra/model'
import { unixEpoch } from '@/utils/date-util'
import { Member } from '@/features/iam/members/Member'
import { Team } from './Team'
import { TeamRole } from './TeamRole'
import { Id } from '@/infra/id'

export type TeamMemberProps = ModelProps<TeamMember>

/**
 * A member of a team.
 */
export class TeamMember extends Model<TeamMember> {
  @observable accessor workspaceId = Id.none
  @observable accessor inactive = false
  @observable accessor dateCreated: Date = unixEpoch()
  @observable accessor dateModified: Date = unixEpoch()
  @observable accessor member = Member.none
  @observable accessor team = Team.none
  @observable accessor teamRole = TeamRole.none

  static get none(): TeamMember {
    return lazyNone()
  }

  /**
   * The member's permissions within the team, granted by their team role.
   */
  @computed
  get permissions() {
    return this.teamRole.permissions
  }
}

const lazyNone = once(() => new TeamMember())
